import { Injectable } from '@angular/core';
import { Observable, Observer } from 'rxjs';
import * as socketIo from 'socket.io-client';
import { Discharge } from '../shared/models/Discharge';
import { DischargeForPrint } from '../shared/models/DischargeForPrint';

const SERVER_URL = 'http://localhost:3010';



@Injectable({
  providedIn: 'root'
})
export class PrinterService {
  private socket;
  currentObserver: Observer<any>;

  constructor() {
    // Inicializar la conexión del socket en el constructor
    this.socket = socketIo(SERVER_URL);

    // Manejo de eventos de errores en la conexión del socket
    this.socket.on('connect_error', (error: any) => {
      console.error('Error de conexión al servidor de impresión', error);
      this.currentObserver.error(error);
      // Puedes implementar una lógica de reintentos aquí si es necesario
    });
  }

  public printTicket(discharge: DischargeForPrint): Observable<any> {

    return Observable.create(
      (obs: Observer<any>) => {
        this.currentObserver = obs;
        this.socket = socketIo(SERVER_URL);
        this.socket.emit('printTicket', discharge);

        this.socket.on('ticketPrinted', (data: any) => {
          console.log('ticket impreso');
          console.log(data);
          this.socket.close();
          obs.next(data);
          this.currentObserver.complete();
        });
        this.socket.on('connect_error', (error: any) => {
          console.error('error', error);
          this.currentObserver.error(error);
          this.socket.close();
        });
      });
  }
  public hasPaper(): Observable<any> {
    return Observable.create(
      (obs: Observer<any>) => {
        this.currentObserver = obs;
        this.socket = socketIo(SERVER_URL);
        this.socket.emit('hasPaper');
        this.socket.on('hasPaperResponse', (data: any) => {
          console.log('response of has paper');
          console.log(data);
          this.socket.close();
          obs.next(data);
          this.currentObserver.complete();
        });
        this.socket.on('connect_error', (error: any) => {
          console.error('error', error);
          this.currentObserver.error(error);
          this.socket.close();
        });
      });
  }
}
